














import { Vue, Component } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "automation-webhooks-overview": () =>
      import(
        "@/components/app/admin/settings/webhooks/automationWebhooksOverview.vue"
      )
  }
})
export default class WebhooksSettingsView extends Vue {
  // Methods

  public createWebhook() {
    if (!this.canCreate) return;
    this.$store.dispatch(`data/${DataModules.WEBHOOKS}/openManageModal`);
  }

  // Computed

  public get canCreate() {
    return this.$userCan("create_webhook");
  }

  public get title() {
    return this.$t("_.webhooks");
  }

  public get cta() {
    if (!this.canCreate) return "";

    return this.$t("_action.create_webhook");
  }
}
